module.exports = __webpack_public_path__ + "img/brew4.c69ec365.png";